import gradingSystem_0 from "../../images/projects/gradingSystem/0.PNG";
import gradingSystem_1 from "../../images/projects/gradingSystem/1.PNG";
import gradingSystem_2 from "../../images/projects/gradingSystem/2.PNG";
import gradingSystem_3 from "../../images/projects/gradingSystem/3.PNG";
import gradingSystem_4 from "../../images/projects/gradingSystem/4.PNG";
import gradingSystem_5 from "../../images/projects/gradingSystem/5.PNG";
import gradingSystem_6 from "../../images/projects/gradingSystem/6.PNG";

export default function gradingSystemImages() {
  return [
    gradingSystem_0,
    gradingSystem_1,
    gradingSystem_2,
    gradingSystem_3,
    gradingSystem_4,
    gradingSystem_5,
    gradingSystem_6,
  ];
}